import store from "@/store";

export const qrList = {
  path: "/qr",
  name: "qr-admin",
  meta: { requiresAuth: true },
  component: () => import("@/views/ADMIN/Qr.vue"),
  beforeEnter: async (to, from, next) => {
    try {
      await store.dispatch("sidebar/getModules", {
        id_privilegio: store.getters["loginModule/idPrivilegio"],
        id_grupo: store.getters["loginModule/idGrupo"],
      });
      return next()
    } catch (_) {
      next(false);
    }
  },
  redirect: { name: "qr-dashboard" },
  children: [
    {
      path: "dashboard",
      name: "qr-dashboard",
      component: () => import("@/components/Qr/Dashboard/QrDashboard.vue"),
    },
    {
      path: "codigos",
      name: "qr-list",
      component: () => import("@/components/Qr/Codigos/QrLista.vue"),
    },
    {
      path: "detalle/:id",
      name: "qr-detalle",
      component: () => import("@/components/Qr/Codigos/QrDetalle.vue"),
    },
    {
      path: "carpetas",
      name: "qr-folders",
      component: () => import("@/components/Qr/Carpetas/QrCarpetas.vue"),
    },
    // Crear, duplicar (?copiar=<id>) y editar comparten pantalla, como epp-crear y epp-editar
    {
      path: "crear",
      name: "qr-crear",
      component: () => import("@/components/Qr/Codigos/QrForm.vue"),
    },
    {
      path: "editar/:id",
      name: "qr-editar",
      component: () => import("@/components/Qr/Codigos/QrForm.vue"),
    },
  ],
};
